(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-exclusions/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/accountservices/player-exclusions/assets/javascripts/prescript.js'); 'use strict';

svs = svs || {};
svs.accountservices = svs.accountservices || {};
svs.accountservices.player_exclusions = svs.accountservices.player_exclusions || {};
 })(window);